import { Primer } from '@primer-io/checkout-web';
import { PackageIdentity } from '@project-gd-x/dating-site-contracts/src/gen/gdx/gateway/web/payment/v2/package_pb';

import { PaymentStateCard } from '@/pages/payment/store/payment-state';
import { getPrimerPaymentForm } from '@/services/api/payment/payment-api';
import { ExtractClassFields } from '@/type';

type PrimerPurchaseTokenArg = {
  pkg: ExtractClassFields<PackageIdentity>;
  card: PaymentStateCard;
};

export async function primerPurchaseToken({ pkg, card }: PrimerPurchaseTokenArg) {
  const res = await getPrimerPaymentForm({
    package: {
      id: pkg.id,
      offerId: pkg.offerId,
    },
    paymentSource: 'one-click',
    cardId: card.id,
  });

  const clientToken = res.sessionToken;
  const targetAnalyticsId = res.methodId;

  const headless = await Primer.createHeadless(clientToken, {
    onCheckoutComplete: (data) => console.log('Success', data),
    onAvailablePaymentMethodsLoad() {
      //checkout won't initilize witout this callback
    },
  });
  await headless.start();

  const vaultManager = headless.createVaultManager();

  const vaultedPaymentMethodList = await vaultManager.fetchVaultedPaymentMethods();

  const cardSelected = vaultedPaymentMethodList.find(
    (method) => method.analyticsId === targetAnalyticsId,
  );

  await vaultManager.startPaymentFlow(cardSelected?.id ?? vaultedPaymentMethodList[0].id);
}
